export function RecyclerProgramIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_recycler_program_icon)'>
        <path
          d='M9 10.5L10.5 9L9 7.5M10.5 9H9.28444C8.81483 9 8.58003 9 8.3669 8.93527C8.17821 8.87797 8.00268 8.78403 7.85034 8.65882C7.67826 8.51739 7.54801 8.32201 7.28752 7.93128L7.16667 7.75M9 4.5L10.5 3L9 1.5M10.5 3H9.28444C8.81483 3 8.58003 3 8.3669 3.06473C8.17821 3.12203 8.00268 3.21597 7.85034 3.34118C7.67826 3.48261 7.54801 3.67799 7.28752 4.06872L4.71248 7.93128C4.45199 8.32202 4.32174 8.51739 4.14966 8.65882C3.99732 8.78403 3.82179 8.87797 3.6331 8.93527C3.41997 9 3.18517 9 2.71556 9H1.5M1.5 3H2.71556C3.18517 3 3.41997 3 3.6331 3.06473C3.82179 3.12203 3.99732 3.21597 4.14966 3.34118C4.32174 3.48261 4.45199 3.67798 4.71248 4.06872L4.83333 4.25'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_recycler_program_icon'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
